import React from "react";

import Strf from "shared/components/Strf";
import Str from "shared/components/Str";

// Show this when talking to an admin (typically Alice).
const FeedbackBannerMessage = () => (
	<Strf vars={{
		question: (
			<span role="img" aria-label="">👀</span>
		),
		helpPageCTA: (
			<a className="banner-link" rel="noopener noreferrer" href="https://help.okcupid.com">
				<Str>Check out our help page!</Str>
			</a>
		),
	}}>
		$question Have a question? $helpPageCTA
	</Strf>
);

export default FeedbackBannerMessage;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/FeedbackBanner.jsx